import { SettingsInformationVm, SpecialSituationMessageVm } from './viewModel';
import { SettingsInformation, SpecialSituationMessage } from '../../../models'

const createSettingsInformationVm = (): SettingsInformationVm => ({
    termsOfUse: '',
    blockedAccount: '',
    maxSizeAttachment: 1,
    specialSituationMessage: createSpecialSituationMessageVm()
});

const createSpecialSituationMessageVm = (): SpecialSituationMessageVm => ({
    dateFrom: null,
    dateTo: null,
    message: ''
});

const mapSettingsInformationToSettingsInformationVm = (settingsInformation: SettingsInformation): SettingsInformationVm => ({
    termsOfUse: settingsInformation.termsOfUse,
    blockedAccount: settingsInformation.blockedAccount,
    maxSizeAttachment: settingsInformation.maxSizeAttachment,
    specialSituationMessage: mapSpecialSituationMessageSpecialSituationMessageVm(settingsInformation.specialSituationMessage),
});

const mapSpecialSituationMessageSpecialSituationMessageVm = (specialSituationMessage: SpecialSituationMessage): SpecialSituationMessageVm => ({
    dateFrom: formatDate(specialSituationMessage.dateFrom),
    dateTo: formatDate(specialSituationMessage.dateTo),
    message: specialSituationMessage.message,
});

function formatDate(date: Date) {
    return new Date(date);
};
export default {
    createSettingsInformationVm,
    createSpecialSituationMessageVm,
    mapSettingsInformationToSettingsInformationVm,
    mapSpecialSituationMessageSpecialSituationMessageVm,
};